// eslint-disable-next-line prefer-destructuring
const CORVETTE_HOST = process.env.CORVETTE_HOST;
type SearchParams = {
  [key: string]: any;
};
export enum SigninRefPath {
  boostOnboarding = '/mfe/cpd/boost/onboarding',
  carGarage = '/mfe/member/auto-garage/detail',
  creditCards = '/mfe/member/credit-cards/offers',
  noDingCreditCards = '/mfe/member/credit-cards/offers?efp=applywithconfidence',
  creditReport = '/mfe/credit/report/experian/now',
  creditHub = '/mfe/credit/credithub/experian',
  creditLock = '/mfe/regulatory/credit-lock',
  darkWebScan = '/identity/activity?scantype=t',
  finRecurringPayment = '/mfe/member/finances/recurring-payments',
  insuranceHub = '/mfe/member/insurance/hub',
  monCreateAccount = '/mfe/money/create-account',
  personalLoans = '/mfe/member/loans/personal-loans',
  protection = '/mfe/protection/protection-center',
  smartMoneyOnboarding = '/mfe/money/onboarding',
  securityFreeze = '/mfe/regulatory/security-freeze',
  unifiedAlerts = '/mfe/member/unifiedalerts/all',
  upgrade = '/mfe/member/upgrade'
}
export enum CTApath {
  registration = '/registration',
  getStarted = '/registration/getStarted',
  loginIndex = '/login/index',
  mobileMatchGetStarted = '/registration/mobile-match/get-started'
}
export const formCTAurl = (params: SearchParams, url: string = CTApath.getStarted) => {
  const defaultParams = { br: 'exp' };
  const fullUrl = url.includes('.') ? new URL(url) : new URL(`${CORVETTE_HOST}${url}`);
  const existingParamsOfTheUrl = new URLSearchParams(fullUrl.search);
  const allParams = { ...defaultParams, ...params };
  Object.entries(allParams).forEach(([key, value]) => {
    existingParamsOfTheUrl.set(key, value);
  });
  fullUrl.search = existingParamsOfTheUrl.toString();
  return fullUrl.toString();
};
